import React from "react";
import MySignatureManager from "../../common/signature/MySignatureManager";

// Dùng chung 1 chữ ký mặc định cho Payment Request lẫn Purchase Requisition / Order.
const MySignaturePanel = () => (
  <MySignatureManager
    description="Create or upload your default signature. It's embedded on the printed form when you sign a purchase requisition or purchase order — in the Portal or with Sign now in the approval email."
  />
);

export default MySignaturePanel;
